// extracted by mini-css-extract-plugin
export default {"p_content":"dfcb45ea80"};